<script>
export default {
  name: 'DataTableCalendarButton',
  emits: ['click'],
  props: {
    tooltip: { type: String, default: 'Click to see details' },
    iconSizeClass: { type: String, default: null },
  },
}
</script>

<template lang="pug">
button.btn.btn-link.text-primary.py-0.px-1(
  @click="$emit('click', $event)"
  type="button"
  v-tooltip.options="{ title: tooltip, placement: 'left' }"
)
  i.bi-calendar4(:class="iconSizeClass")
</template>
